import http, { formConfig } from "@/utils/http";
const url = action => `/sync/mailcreate/${action[0]}`;

export default class LDAPEXTEND {
  static ENTRY_WRITEBACK(data) {
    return http.post(url`entrywriteback`, data, formConfig);
  }
}
